<template>
    <div
        class="card-overlay absolute top-0 left-0 bottom-0 right-0 w-full h-full bg-white/[0.85] backdrop-blur-sm z-20 flex justify-center items-center p-5"
        :class="{ 'flex-col': !card.topCard, 'flex-row': card.topCard }"
    >
        <div
            class="text-center"
            :class="{ 'mb-6': !card.topCard, 'p-4': card.topCard }"
        >
            <i class="fas fa-info-circle text-orange fa-2x mb-5"></i>
            <p class="text-gray-800">You're likely ineligible for the</p>
            <p class="text-gray-800 font-bold text-lg mb-5">{{ card.title }}</p>

            <button
                type="button"
                @click.prevent="openExclusionsSidebar"
                class="rounded-md bg-white py-2.5 px-3.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            >
                See Why <i class="fa-light fa-arrow-right ml-2"></i>
            </button>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useNextCardStore } from "@/store/nextcard";

export default {
    name: "CardExclusion",
    props: {
        card: Object,
        offenders: {
            type: Object,
            default: {},
        },
    },
    data: () => ({}),
    computed: {
        ...mapState(useNextCardStore, [
            "showExclusionsSidebar",
            "activeNextCard",
        ]),
        cdnUrl() {
            return window.cdnUrl;
        },
    },
    methods: {
        ...mapActions(useNextCardStore, [
            "setActiveNextCard",
            "setExclusionsSidebar",
        ]),
        openExclusionsSidebar() {
            const cardCopy = { ...this.card };
            
            if (cardCopy.card_image && cardCopy.card_image.path && cardCopy.card_image.file_name) {
                cardCopy.image = `${this.cdnUrl}/${cardCopy.card_image.path}/_small/${cardCopy.card_image.file_name}`;
            }
            
            this.setActiveNextCard({
                card: cardCopy,
                offenders: this.offenders,
            });
            this.setExclusionsSidebar(true);
        },
        closeExclusionsSidebar() {
            this.setExclusionsSidebar(false);
        },
    },
    mounted() {},
};
</script>
